import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";

import ViewInteressesControle from "../views/ViewInteressesControle";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

const InteressesControle: React.FC = () => (
  <>
    <ContainerComponente>
      <ViewAppBar />
      <ViewInteressesControle />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default InteressesControle;
